import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterMailchimpVendorCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterMailchimpVendorParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vendor/mailchimp';
  public override setParameters(parameters: IRegisterMailchimpVendorParameters) {
    this._commandBody = parameters;
  }
}

export interface IRegisterMailchimpVendorParameters extends ICommandParameters {
  userId: string;
  code: string;
}
